import { Button, Divider, Grid, Stack, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import FloorMap from 'components/FloorMap'
import OpenStressMap from 'components/Map'
import { format } from 'date-fns'
import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export default function EventDetail() {
  const UIPrefectures = useAppSelector((s) => s.UI.prefectures)
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const event = useAppSelector((s) =>
    s.Event.list.find((f) => f.id === Number(id))
  )
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(
      UIAction.setBreadcrumbs([
        {
          text: 'ホーム',
          url: '/',
        },
        {
          text: 'イベント一覧',
          url: '/event',
        },
        {
          text: 'イベント詳細',
          url: '/event/' + event?.id,
        },
      ])
    )
  }, [dispatch, event?.id, event?.name])
  if (!event) return null
  return (
    <Grid container spacing={1} mt={2}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          fontWeight="bold"
          component="h2"
          sx={{ borderBottom: 2 }}
        >
          イベント詳細
        </Typography>
      </Grid>
      <Grid item xs={12} ml={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={7}>
            <Stack ml={1}>
              <Typography variant="h6" component="h3" fontWeight="bold">
                {event.name}
              </Typography>
              <Typography
                gutterBottom
                variant="subtitle1"
                component="h4"
                mt={1}
                fontWeight="bold"
              >
                基本情報
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                component="h6"
                sx={{
                  fontWeight: 'bold',
                }}
              >
                開催場所
              </Typography>
              <Typography gutterBottom variant="body1" component="h6" mb={2}>
                {UIPrefectures.find((f) => f.id === event.prefectureId)?.name +
                  event.address}
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                component="h6"
                sx={{
                  fontWeight: 'bold',
                }}
              >
                開催期間
              </Typography>
              <Typography gutterBottom variant="body1" component="h6" mb={2}>
                {format(event.startDate, 'yyyy/MM/dd')} から{' '}
                {format(event.endDate, 'yyyy/MM/dd')} まで
              </Typography>
              <Typography
                gutterBottom
                variant="body1"
                component="h6"
                sx={{
                  fontWeight: 'bold',
                }}
              >
                概要説明文
              </Typography>
              <Typography gutterBottom variant="body1" component="h6">
                {event.summary}
              </Typography>
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              width={300}
              src={event.image}
              alt={event.name}
              loading="lazy"
              crossOrigin="anonymous"
            />
          </Grid>
        </Grid>
        {event.rewardSummary && event.rewardImage ? (
          <>
            <Divider sx={{ my: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={7}>
                <Stack ml={1}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    component="h6"
                    sx={{
                      fontWeight: 'bold',
                    }}
                  >
                    クリア特典
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body1"
                    component="h6"
                    mb={2}
                  >
                    {event.rewardSummary}
                  </Typography>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <img
                  width={300}
                  src={event.rewardImage}
                  alt={event.name + event.id}
                  loading="lazy"
                  crossOrigin="anonymous"
                />
              </Grid>
            </Grid>
          </>
        ) : (
          ''
        )}
      </Grid>
      <Grid item xs={12}>
        {event.useGPS
          ? event.checkpoints.length > 0 && (
              <OpenStressMap positions={event.checkpoints} />
            )
          : event.floors.length > 0 && (
              <FloorMap floors={event.floors} positions={event.checkpoints} />
            )}
      </Grid>
      <Grid
        item
        xs={12}
        ml={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Button
          color="inherit"
          variant="outlined"
          sx={{
            px: 12,
            borderColor: '#aaa',
            borderRadius: 2,
            mt: 4,
          }}
          onClick={() => navigate('/event/' + id + '/result')}
        >
          イベント実績
        </Button>
      </Grid>
    </Grid>
  )
}
